import { useEffect, useState } from "react";
import { IconButton, Popover, Stack } from "@introist/react-foundation/v2";
import { TagSelectorList } from "../../../../../modules/system/tags/TagSelector";
import { Tag } from "../../../../../modules/system/tags/useTags";

export const FieldSelector = ({
  onSelect,
  forceOpen,
  preSearch,
  workflowId
}: {
  onSelect: (path: string, title: string) => boolean;
  forceOpen?: boolean;
  preSearch?: string;
  workflowId?: string;
}) => {
  const [popoverRef, setPopoverRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (forceOpen !== undefined) setOpen(forceOpen);
  }, [forceOpen]);

  return (
    <>
      <Stack ref={setPopoverRef}>
        <IconButton icon="attributeGroup" onClick={() => setOpen(!open)} size="large" />
      </Stack>

      <Popover
        referenceElement={popoverRef}
        open={open}
        onClose={() => setOpen(false)}
        attachToRef={false}
      >
        {open && (
          <TagSelectorList
            ctx={{ workflowId }}
            onSelect={(tag: Tag) => {
              if (onSelect(tag.tag, tag.fullTitle ?? tag.title)) setOpen(false);
            }}
          />
        )}
      </Popover>
    </>
  );
};
